const buttonLoadMore = document.querySelector('[load-more-legislation]');

let customPage = 2;

if (buttonLoadMore) {
	buttonLoadMore.addEventListener('click', function(e) {
		const url = this.dataset.url;
		const fullUrl = url;

		const listElement = document.querySelector('[load-more-legislation-list]');

		window.axios.get(fullUrl, {params: {customPage: customPage}})
			.then(response => {

				let html = response.data.data.map(legislation =>  `<li><a href="${legislation.file_url}" download=""><svg class="ic--i"><use xlink:href="#ic-download"></use></svg>${legislation.name}</a></li>`);

				listElement.innerHTML = html.join('')

				if(!response.data.next_page_url) {
					buttonLoadMore.classList.add('d-none');
				}

				customPage++;
			}).catch(err => {
				siteAlert({
					text: 'Não foi possível carregar',
					class: 'alert--i_error',
					seconds: 7000
				})
			});
	});
}
